package io.horion.auth.api.models.domain.profile

import io.horion.auth.domain.models.Role
import kotlinx.serialization.Serializable

@Serializable
data class User(
    val id: String,
    val uuid: String,
    val firstName: String,
    val lastName: String,
    val avatar: String,
    val role: Role,
    val isTwoFactorEnabled: Boolean = false,
    val city: String = "Douala",             // Ex: Douala, Yaoundé
    val country: String = "Cameroun",        // Ex: Cameroun
    val countryCode: String = "cm",          // Ex: cm
    val timezone: String = "Africa/Douala",
    val isLoggedIn: Boolean = true,
    val loginTimestamp: Long = 0L,
    val createdAt: String,
    val updatedAt: String
)
